import { useTranslation } from 'react-i18next';

import { BackToPageButton } from '@/components/back-to-page-button/back-to-page-button';
import { PageHeader } from '@/components/page-header/page-header';
import { Typography } from '@/components/typography/typography';

import { Stack } from '@/lib/shadcn/components/ui/stack/stack';

import { ErrorPageLayout } from './error-page-layout';
import { ForbiddenIcon } from './icons/forbidden-icon.tsx';

export function ForbiddenErrorPage() {
  const { t } = useTranslation();

  return (
    <ErrorPageLayout
      headerComponent={<PageHeader right className="w-full justify-between" />}
    >
      <Stack gap={11} align="center" className="mt-[11vh] flex-1">
        <ForbiddenIcon />
        <Stack gap={15} align="center">
          <Stack gap={6} className="text-center">
            <Typography.h3 className="text-teal-500">
              {t('errors.forbidden.title')}
            </Typography.h3>
            <Typography.p3 className="text-slate-400">
              {t('errors.forbidden.text')}
            </Typography.p3>
          </Stack>
          <BackToPageButton variant="main" size="l" className="w-full py-unit-9">
            <Typography.p1>{t('errors.forbidden.button')}</Typography.p1>
          </BackToPageButton>
        </Stack>
      </Stack>
    </ErrorPageLayout>
  );
}
